module.exports = __webpack_public_path__ + "static/media/drawing.5804e478.jpg";